import React from 'react';
import { useLocation } from 'react-router-dom';
import s from './ColorItem.module.scss';
export const ColorItem = ({ ...props }) => {
  const {
    bg = '#ccc',
    changeItem,
    item,
    currentValue,
    name,
    isUrlLoaderActive,
  } = props;
  let value: any;
  const search = useLocation().search;
  let attributeIsActive = new URLSearchParams(search).get(name);
  if (attributeIsActive && isUrlLoaderActive) {
    value = item.metadata.option;
  } else {
    value = item.assetId;
  }

  // Vivid API image URL (if available)
  const vividImg: string | undefined = item.metadata?._img;

  return (
    <div
      style={vividImg ? undefined : { background: bg }}
      onClick={() => changeItem(item.assetId, item.label)}
      className={`${s.colorItem} ${currentValue === value ? s.active : null} ${vividImg ? s.hasImage : ''}`}
    >
      {vividImg && (
        <div className={s.item_img_wrap}>
          <div
            className={s.item_img}
            style={{ backgroundImage: `url("${vividImg}")` }}
          />
        </div>
      )}
    </div>
  );
};
